import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=4e3d4e17&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d4e17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20261103171319/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e3d4e17')) {
      api.createRecord('4e3d4e17', component.options)
    } else {
      api.reload('4e3d4e17', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=4e3d4e17&scoped=true", function () {
      api.rerender('4e3d4e17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/loader.vue"
export default component.exports